import { render, staticRenderFns } from "./StateEnrolments.vue?vue&type=template&id=47b7c886&scoped=true&"
import script from "./StateEnrolments.vue?vue&type=script&lang=js&"
export * from "./StateEnrolments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b7c886",
  null
  
)

export default component.exports